import { setTrackView, useTracking } from '@vfit/shared/data-access';
import { useQueryClient } from 'react-query';
import { getTagging, getUserInfo } from '../../checkout.utils';
import { withAnimationDelay } from '../../hoc/withAnimationDelay';

const TaggingComponent = () => {
  const client = useQueryClient();
  const tagging = getTagging('payment method', 'fixed', client);

  const { trackView } = useTracking({
    event: ['checkout_step9'],
    event_label: 'payment method',
    opts: tagging?.opts,
    cartProduct: tagging?.trackingProduct,
    pageProduct: tagging?.pageProductsInfo,
    visitorTrackingOpts: getUserInfo(),
  });
  setTrackView(trackView);
  return null;
};

const TaggingRecurrentPaymentCard = withAnimationDelay()(TaggingComponent);

export default TaggingRecurrentPaymentCard;
